import { render, staticRenderFns } from "./productStock.vue?vue&type=template&id=7666a6a9&"
import script from "./productStock.vue?vue&type=script&lang=js&"
export * from "./productStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports